import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgRekeningnummerWijzigen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00A75D"
      d="M32.88 12.01H7.12a1.11 1.11 0 0 0-1.11 1.11v13.76c0 .613.497 1.11 1.11 1.11h25.76a1.11 1.11 0 0 0 1.11-1.11V13.12a1.11 1.11 0 0 0-1.11-1.11"
    />
    <path
      stroke="#6FBC85"
      strokeMiterlimit={10}
      d="M8 19h12M8 21h5"
    />
    <path
      fill="#fff"
      d="M34 15.02H6.02V17H34z"
    />
    <path
      fill="#A8D3AF"
      fillRule="evenodd"
      d="m28.49 8.69 3.54 3.54-19.06 19.04c-.49.49-1.11.83-1.78.99l-3.56.82.82-3.56c.16-.67.5-1.29.99-1.78z"
      clipRule="evenodd"
    />
    <path
      fill="#A8D3AF"
      d="M33.078 7.626a2.5 2.5 0 0 1 0 3.535l-.354.354-3.535-3.536.353-.353a2.5 2.5 0 0 1 3.536 0"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgRekeningnummerWijzigen);

export default ForwardRef;
